export default {"src":"/_next/static/media/light.5ce0c8a9.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};